import { render, staticRenderFns } from "./notification-handler.vue?vue&type=template&id=0c325b1f"
import script from "./notification-handler.vue?vue&type=script&lang=js"
export * from "./notification-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports